const ResultSearchCriteria = React.createClass({
    propTypes: {
        searchCriteriaKeys: React.PropTypes.array.isRequired,
        selectedIndex: React.PropTypes.number,
        onSearchCriteriaChanged: React.PropTypes.func,
        align: React.PropTypes.oneOf(["left", "center", "right"])
    }, getDefaultProps() {
        return {
            selectedIndex: 0, onSearchCriteriaChanged: function () {
            }, align: "right"
        }
    }, handleSearchCriterieChange(searchCriteriaIndex) {
        let selectedKey = this.props.searchCriteriaKeys[searchCriteriaIndex];
        this.props.onSearchCriteriaChanged(selectedKey, searchCriteriaIndex);
    }, render: function () {
        let {
            searchCriteriaKeys, selectedIndex
        } = this.props;
        if (selectedIndex === -1) return null;
        const isHide = searchCriteriaKeys.find(searchCriteria => searchCriteria.key === "hide");
        if (isHide) return null;
        return (
            <div className="search-criteria">
                <ul className="pagination">
                    {searchCriteriaKeys.map((searchCriteriaKey, i) =>
                        <li className={selectedIndex === i ? "active" : ""}
                            id={searchCriteriaKey.label}
                            onClick={() => this.handleSearchCriterieChange(i)}>
                            <a href="#">{searchCriteriaKey.label}</a>
                        </li>)
                    }
                </ul>
            </div>
        )
    }
});